import {
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
    Button,
    Grid2,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useGlobalModalContext } from "../../context/GlobalModalContext";

const MessageDialog = ({ 
  message,
  primaryButtonText,
  secondaryButtonText, 
  onPrimaryClick,
  onSecondaryClick,
  title = ""
}) => {
  const { hideModal } = useGlobalModalContext();

  return (
    <Dialog open onClose={hideModal} maxWidth={"sm"} fullWidth={true}>
      <DialogTitle>
        <h4 className="font-bold text-center">{title}</h4>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={hideModal}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseOutlined />
      </IconButton>
      <DialogContent>
        <div className="text-center mb-4">
          {message}
        </div>
        <Grid2 container spacing={2} justifyContent="center">
          {primaryButtonText && (
            <Grid2>
              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "none" }}
                onClick={() => {
                  onPrimaryClick?.();
                  hideModal();
                }}
              >
                {primaryButtonText}
              </Button>
            </Grid2>
          )}
          {secondaryButtonText && (
            <Grid2>
              <Button
                variant="outlined"
                size="small" 
                sx={{ textTransform: "none" }}
                onClick={() => {
                  onSecondaryClick?.();
                  hideModal();
                }}
              >
                {secondaryButtonText}
              </Button>
            </Grid2>
          )}
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export default MessageDialog;